module.exports = __webpack_public_path__ + "static/media/noPlans.1a691361.svg";